module.exports = __webpack_public_path__ + "static/media/fan.c3909e0e.png";